/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./createTag.vue?vue&type=template&id=72a1a002&"
import script from "./createTag.vue?vue&type=script&lang=js&"
export * from "./createTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports